/** Client-side gate for Yjs collaborative editing (mirrors cloud `wave_yjs_enabled`). Default: enabled. */
export function isWaveYjsEnabled() {
    if (typeof import.meta !== "undefined") {
        const env = import.meta;
        const raw = env.env?.VITE_WAVE_YJS_ENABLED;
        if (raw === true || raw === "true" || raw === "1")
            return true;
        if (raw === false || raw === "false" || raw === "0")
            return false;
    }
    if (typeof globalThis !== "undefined") {
        const cfg = globalThis
            .__WAVE_YJS_ENABLED__;
        if (cfg === false)
            return false;
        if (cfg === true)
            return true;
    }
    return true;
}
export function applyWaveYjsRuntimeFlag(enabled) {
    globalThis.__WAVE_YJS_ENABLED__ =
        enabled;
}
/** Yjs path when flag is on or the wave is already `yjs-v1` on cloud. */
export function shouldUseWaveYjs(formatVersion) {
    if (isWaveYjsEnabled())
        return true;
    return formatVersion === "yjs-v1";
}
